module.exports = __webpack_public_path__ + "img/en.d7e8bd91.png";